export { HomePage } from "../components/pages/home";
export { SectionPage } from "../components/pages/section";
export { TagPage } from "../components/pages/tag";
export { PublicationsPage } from "../components/pages/publications";
export { SearchPage } from "../components/pages/search";
export { CatalogPage } from "../components/pages/catalog";
export { NotFoundPage } from "../components/pages/not-found";
export { BlogPage } from "../components/pages/blog";
export { PhdPage } from "../components/pages/phd";
export { PeoplePage } from "../components/pages/people";
export { AuthorPage } from "../components/pages/author";
export { LoginPage } from "../components/pages/login";
export { SignUpPage } from "../components/pages/signup";
export { ForgotPasswordPage } from "../components/pages/forgot-password";
export { VerifyEmailPage } from "../components/pages/verify-email";
export { HomePagePreview } from "../components/pages/home-preview";
export { ResetPasswordPage } from "../components/pages/reset-password";
